import { useRef, useState } from 'react'
import { AppItemRecommendations } from 'components/pages/CartPage/ItemRecommendations/types/query'
import ItemRecommendationCard from 'components/pages/CartPage/ItemRecommendations/ItemRecommendationCard'

type Props = {
  items: NonNullable<
    AppItemRecommendations['currentCart']
  >['itemRecommendations']
  openModal: (itemId: number) => void
}

const RecommendationGroup = ({ items, openModal }: Props) => {
  const ref = useRef<HTMLInputElement>(null)
  const [leftArrowVisible, setLeftArrowVisible] = useState<boolean>(false)
  const [rightArrowVisible, setRightArrowVisible] = useState<boolean>(
    items.length > 3
  )

  const scrollLeft = () => {
    if (ref && ref.current) {
      ref.current.scrollLeft -= 130
      if (ref.current.scrollLeft === 0) setLeftArrowVisible(false)
      if (
        Math.round(
          ref.current.scrollWidth -
            ref.current.offsetWidth -
            ref.current.scrollLeft
        ) !== 0
      )
        setRightArrowVisible(true)
    }
  }

  const scrollRight = () => {
    if (ref && ref.current) {
      ref.current.scrollLeft += 130
      if (ref.current.scrollLeft !== 0) setLeftArrowVisible(true)
      if (
        Math.round(
          ref.current.scrollWidth -
            ref.current.offsetWidth -
            ref.current.scrollLeft
        ) === 0
      )
        setRightArrowVisible(false)
    }
  }

  return (
    <div>
      <div className="mt-2">
        <div className="flex flex-row relative">
          {leftArrowVisible && (
            <button
              aria-label="Scroll to left"
              className="z-10 absolute left-0 top-0 bottom-6 flex items-center cursor-pointer"
              onClick={scrollLeft}
              type="button"
            >
              <div
                className={`w-12 h-12 rounded-full flex justify-center items-center ml-2
              transition duration-200 ease-in-out text-orange-400 hover:text-orange-600 bg-orange-100 hover:bg-orange-200 hover:scale-110`}
              >
                <svg
                  className="w-8 h-8 text-orange-400 hover:text-orange-600"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    clipRule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    fillRule="evenodd"
                  />
                </svg>
              </div>
            </button>
          )}

          <div
            ref={ref}
            aria-label="Add items"
            className="flex flex-row space-x-4 py-2 overflow-scroll invisible-scroll"
            role="list"
          >
            {items.map((item) => (
              <div key={item.id} aria-label={item.item.name} role="listitem">
                <ItemRecommendationCard
                  locationItem={item}
                  openModal={openModal}
                />
              </div>
            ))}
          </div>

          {rightArrowVisible && (
            <button
              aria-label="Scroll to right"
              className="z-10 absolute top-0 bottom-6 top-0 right-0 flex items-center cursor-pointer"
              onClick={scrollRight}
              type="button"
            >
              <div
                className={`w-12 h-12 rounded-full flex justify-center items-center mr-2
              transition duration-200 ease-in-out text-orange-400 hover:text-orange-600 bg-orange-100 hover:bg-orange-200 hover:scale-110`}
              >
                <svg
                  className="w-8 h-8 text-orange-400 hover:text-orange-600"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    clipRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    fillRule="evenodd"
                  />
                </svg>
              </div>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default RecommendationGroup
